// extracted by mini-css-extract-plugin
module.exports = {"container":"NsTab_container_1cL-O","active":"NsTab_active_35M3p"};